import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Dialog from '@material-ui/core/Dialog';
import axios from 'axios';
import DialogTitle from '@material-ui/core/DialogTitle';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import DialogActions from '@material-ui/core/DialogActions';
import Input from '@material-ui/core/Input';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import DialogContent from '@material-ui/core/DialogContent';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import { useForm } from 'react-hook-form';
import { setListTeacher } from '../actions/teacherActions';

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

/**
 * Function to add the pricing plans
 * @param {*} props
 * @returns
 */
function SubjectAdd(props) {
  const {
    openStatusAddSubjects, onClosedAddSubjects
  } = props;

   /**
  * const teacher list
  */
  const listTeacher = useSelector(state => state.teacher, shallowEqual);
  const [schoolYear, setSchoolYear] = useState([]);
  const [courses, setCourses] = useState([]);
  const [subjects, setSubjects] = useState([]);
  const [schoolYearId, setSchoolYearId] = useState("");
  const [courseId, setCourseId] = useState("");
  const [subjectId, setSubjectId] = useState("");
  const [helperTextType, setHelperTextType] = React.useState();
  const [errorType, setErrorType] = React.useState(false);
  const dispatch = useDispatch();
  const { register, handleSubmit, errors } = useForm();  
  const endpointAll = 'http://127.0.0.1:8000/api';
  const [open, setOpen] = useState(false);
  const [openError, setOpenError] = useState(false);
  const [errorMessage, setErrorMessage] = useState(false);

  const handleCloseError = (event, reason) => {
    setOpen(false);
  };

  const handleClose = (event, reason) => {
    setOpenError(false);
  };

 /**
  * Method to set the list pricing plans
  */
  const getAllSchoolYear = async() => {
    const requestBody = {
      status: "Actual"
    };
    const response = await axios.post(endpointAll+'/school-year/findByStatus' , requestBody);
    setSchoolYear(response.data);
  };

/**
 * Retrieve pricing plan list
 */
  useEffect(() => {
    getAllSchoolYear();  
  }, [openStatusAddSubjects]);

  /**
  * Method to set the list pricing plans
  */
  const getAllCourses = async() => {
    const requestBody = {
      status: "Activo",
      year: schoolYearId.id
    };
    const response = await axios.post(endpointAll+'/course/findByStatusAndYear' , requestBody);
    setCourses(response.data);
  };

  /**
   * Retrieve pricing plan list
   */
    useEffect(() => {
      getAllCourses();  
    }, [schoolYearId]);


   /**
  * Method to set the list pricing plans
  */
   const getAllSubjects = async() => {
    const requestBody = {
      status: "Activo",
      course: courseId.id
    };
    const response = await axios.post(endpointAll+'/course/findByStatusAndCourse' , requestBody);
    setSubjects(response.data);
  };

  /**
   * Retrieve pricing plan list
   */
    useEffect(() => {
      getAllSubjects();  
    }, [courseId]);
  
  /**
 * Method to added the new register in the table
 * @param {data} data
 */
  const handleAdd = (data) => {
    const newListTeacher = [...listTeacher];
    newListTeacher.push(data);
    dispatch(setListTeacher(newListTeacher));
  };


  /**
   * Method to close the dialog and show the success message
   * @param {data} data
   */
  const handleOK = (data) => {
    handleAdd(data.data);
    onClosedAddSubjects();
    setOpen(true);
  };

  /**
   * Method to close the dialog
   */
  const handleError = (response) => {
    if(response.response.data.message.errorInfo[2].includes("Duplicate")){
      setErrorMessage('El profesor ya existe.');
    }else{
      setErrorMessage('La acción no se pudo realizar.');      
    }
    onClosedAddSubjects();
    setOpenError(true);
  };

  /**
   * Method to add the register and create que request
   * @param {*} formData
   */
  const onSubmit = async(formData) => {
        
      const requestBody = {
        name: formData.name,
        email:formData.email,
        phone:formData.phone,
        birthday:formData.birthday,
        nit:formData.nit
      };
      await axios.post(endpointAll, requestBody).then((response) => {
        handleOK(response);
      })
      .catch((e) => {
        handleError(e);
      });
  };

  /**
   * Method to close the dialog
   */
  const handleCloseAction = () => {
    onClosedAddSubjects();
  };

  /**
   * Method to control the combobox of role type
   */
  const handleChangeSchoolYear = (event) => {
    setSchoolYearId(event.target.value);
  };

  /**
   * Method to control the combobox of role type
   */
  const handleChangeCourse = (event) => {
    setCourseId(event.target.value);
  };

  /**
   * Method to control the combobox of role type
   */
  const handleChangeSubject = (event) => {
    setSubjectId(event.target.value);
  };

  return (
    <Grid container justifyContent="center" direction="column">
      <Dialog
        fullWidth
        maxWidth="sm"
        open={openStatusAddSubjects}
        onClose={handleCloseAction}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">Añadir</DialogTitle>
        <DialogContent>
          <form onSubmit={handleSubmit(onSubmit)} id = "addForm">
            <br/>
              <FormControl width="90%" >
              {Array.isArray(schoolYear)?
                    schoolYear.length === 0 ? "Es necesario tener un año lectivo Actual":
                    <div>
                    <InputLabel required error={errorType} htmlFor="status-helper">Año Lectivo:</InputLabel>
                    <Select
                      name="school_year_id"
                      labelId="demo-checkbox-label"
                      id="school_year_id"
                      fullWidth
                      value={schoolYearId}
                      onChange={handleChangeSchoolYear}
                      input={<Input />}
                      MenuProps={MenuProps}
                      style={{width:"200px"}}
                    >
                      <MenuItem name="" value="">
                        Ninguno
                      </MenuItem>
                      
                      {schoolYear.map((value, key) => (
                        <MenuItem name={value} key={key.toString()} value={value}>
                           {value.year }
                        </MenuItem>
                      ))}
                    </Select>
                    </div>
                    : "Es necesario tener un año lectivo Actual"
                    }
               
                    {errorType && <FormHelperText error>{helperTextType}</FormHelperText>}
                  </FormControl>
                  <br/>
              <FormControl width="90%" >
              {Array.isArray(courses)?
                    courses.length === 0 ? "Es necesario tener un curso Activo":
                    <div>
                    <InputLabel required error={errorType} htmlFor="status-helper">Curso:</InputLabel>
                    <Select
                      name="course_id"
                      labelId="demo-checkbox-label"
                      id="course_id"
                      fullWidth
                      value={courseId}
                      onChange={handleChangeCourse}
                      input={<Input />}
                      MenuProps={MenuProps}
                      style={{width:"200px"}}
                    >
                      <MenuItem name="" value="">
                        Ninguno
                      </MenuItem>
                      
                      {courses.map((value, key) => (
                        <MenuItem name={value} key={key.toString()} value={value}>
                           {value.name }
                        </MenuItem>
                      ))}
                    </Select>
                    </div>
                    : "Es necesario tener un curso Activo"
                    }
               
                    {errorType && <FormHelperText error>{helperTextType}</FormHelperText>}
                  </FormControl>
                  <br/>
                  <FormControl width="90%" >
              {Array.isArray(subjects)?
                    subjects.length === 0 ? "Es necesario tener una materia Activa":
                    <div>
                    <InputLabel required error={errorType} htmlFor="status-helper">Materia:</InputLabel>
                    <Select
                      name="subject_id"
                      labelId="demo-checkbox-label"
                      id="subject_id"
                      fullWidth
                      value={subjectId}
                      onChange={handleChangeSubject}
                      input={<Input />}
                      MenuProps={MenuProps}
                      style={{width:"200px"}}
                    >
                      <MenuItem name="" value="">
                        Ninguno
                      </MenuItem>
                      
                      {subjects.map((value, key) => (
                        <MenuItem name={value} key={key.toString()} value={value}>
                           {value.name }
                        </MenuItem>
                      ))}
                    </Select>
                    </div>
                    : "Es necesario tener una materia Activa"
                    }
               
                    {errorType && <FormHelperText error>{helperTextType}</FormHelperText>}
                  </FormControl>
          </form>
        </DialogContent>
        <DialogActions>
          <Button id="button_close" onClick={handleCloseAction}>Cerrar</Button>
          <Button id="button_agree_add_teacher" variant="contained" style={{backgroundColor: "#68dcb9", color: "#FFFFFF"}} type="submit" form="addForm">
            Añadir
          </Button>
        </DialogActions>
      </Dialog>
      <Snackbar open={openError} autoHideDuration={6000} onClose={handleClose} >
        <Alert onClose={handleClose} severity="error" sx={{ width: '100%' }}>
          {errorMessage}
        </Alert>
      </Snackbar>
      <Snackbar open={open} autoHideDuration={6000} onClose={handleCloseError}>
        <Alert onClose={handleCloseError} severity="success" sx={{ width: '100%' }} center>
          La acción se ejecutó de manera correcta.
        </Alert>
      </Snackbar>
    </Grid>
  );
}

SubjectAdd.propTypes = {
  /** status of add dialog */
  openStatus: PropTypes.bool.isRequired,
  /** function of add dialog */
  onClosed: PropTypes.func.isRequired
};

export default SubjectAdd;
